//external
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//internal
import { deleteProductRestriction, getProductRestriction } from 'services/productRestriction/service';
import history from 'services/history';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
//style
import { Attr, AttrName } from './styled';
import { Button, ButtonContainer } from 'styles/components';

export default function ProductRestritionDelete({match}) {
  const productRestrictionId = match.params.id;
  const message = useSelector(state => state.message.data);
  const [productRestriction, setProductRestriction] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (productRestrictionId) {
      dispatch(startRequest());
      getProductRestriction(productRestrictionId).then(data => {
        setProductRestriction(data.data);
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, productRestrictionId]);

  async function handleDelete () {
    dispatch(startRequest());
    deleteProductRestriction(productRestrictionId).then(data => {
      history.push('/premixLabel/product_restriction')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }

  async function handleBack () {
    history.goBack();
  }

  return (
    <>
      <ContentPanel title="Deseja excluir este produto?" message={message}>
        {productRestriction && <>
          <AttrName>Descrição:</AttrName>
          <Attr>{productRestriction.description}</Attr>
          <AttrName>Texto restritivo:</AttrName>
          <Attr>{productRestriction.restrictiveText}</Attr>
          <ButtonContainer>
            <br />
            <Button left={true} cancel={true} onClick={handleBack}>
              Voltar
            </Button>
            <Button onClick={handleDelete}>
              Excluir
            </Button>
          </ButtonContainer>
        </>}
      </ContentPanel>
    </>
  )
}